import styles from "../../../../styles/NavigationLogs.module.css";
const TYPE_CLASSES: Record<string, string> = {
  NAVIGATION: styles.badgeNav,
  CLICK: styles.badgeClick,
  API: styles.badgeApi,
  ERROR: styles.badgeError,
};

export const TypeBadge = ({ type }: { type: string }) => (
  <span className={`${styles.badge} ${TYPE_CLASSES[type] ?? styles.badgeOther}`}>
    {type}
  </span>
);

export const DurationPill = ({ duration }: { duration?: number | null }) => {
  if (duration == null) return <span className={styles.muted}>—</span>;
  const cls =
    duration < 200 ? styles.durFast : duration < 600 ? styles.durMid : styles.durSlow;
  return <span className={`${styles.durationPill} ${cls}`}>{duration}ms</span>;
};

export const UserAvatar = ({ name }: { name?: string | null }) => {
  const initials = name
    ? name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase()
    : "?";
  return <div className={styles.avatar}>{initials}</div>;
};
